import { H2 } from 'src/components/_commons';
import { useGetCurrentUser, useGetIsDarkMode, useGetIsMobile } from 'src/custom-hooks';
import { useMemo } from 'react';
import { useNavigate } from 'react-router';
import * as Subpages from '.';

type typeAdminsSection = '' | 'attendance' | 'av-ushers' | 'board' | 'carts' | 'cleaning' | 'config' | 'geriatrics' | 'groups' | 'hth' | 'logs' | 'map' | 'midweek-meetings' | 'notifications' | 'public-meetings' | 'public-ministry' | 'reports' | 'telephonic' | 'users';

export const AdminsPage = () => {
    const isDarkMode = useGetIsDarkMode();
    const isMobile = useGetIsMobile();
    const navigate = useNavigate();
    const user = useGetCurrentUser();
    //
    const card = `card ${isMobile ? 'pb-2' : ''} ${isDarkMode ? 'bg-dark text-white border-light' : ''} mb-1`;
    const cardHeader = `card-header ${isMobile ? '' : 'd-flex justify-content-start'} ${isDarkMode ? 'text-white' : ''} pe-0`;
    //
    const header = `title-admins h5 ${isMobile ? 'text-center py-1 mb-3' : 'pt-2'} m-0`;
    const headerStyles = { display: isMobile ? 'block' : '', fontSize: '1.4rem', margin: isMobile ? '0 auto' : '0 10px 0 0', width: '140px' };
    //
    const btnClasses = `btn btn-general-blue d-block ${isMobile ? 'mx-auto' : ''} my-1`;
    const btnStyles = { fontSize: '.9rem', marginRight: isMobile ? undefined : '15px', width: isMobile ? '280px' : '140px' };

    const currentSection: typeAdminsSection = useMemo(() => {
        const relativePath = window.location.pathname as string;
        if (relativePath.startsWith('/admins/asistencia')) return 'attendance';
        if (relativePath.startsWith('/admins/av-y-acomodadores')) return 'av-ushers';
        if (relativePath.startsWith('/admins/carritos')) return 'carts';
        if (relativePath.startsWith('/admins/casa-en-casa')) return 'hth';
        if (relativePath.startsWith('/admins/config')) return 'config';
        if (relativePath.startsWith('/admins/geriatricos')) return 'geriatrics';
        if (relativePath.startsWith('/admins/grupos')) return 'groups';
        if (relativePath.startsWith('/admins/informes')) return 'reports';
        if (relativePath.startsWith('/admins/limpieza')) return 'cleaning';
        if (relativePath.startsWith('/admins/logs')) return 'logs';
        if (relativePath.startsWith('/admins/mapa')) return 'map';
        if (relativePath.startsWith('/admins/notificaciones')) return 'notifications';
        if (relativePath.startsWith('/admins/reuniones-entresemana')) return 'midweek-meetings';
        if (relativePath.startsWith('/admins/reuniones-findesemana')) return 'public-meetings';
        if (relativePath.startsWith('/admins/salidas')) return 'public-ministry';
        if (relativePath.startsWith('/admins/tablero')) return 'board';
        if (relativePath.startsWith('/admins/telefonica')) return 'telephonic';
        if (relativePath.startsWith('/admins/usuarios')) return 'users';
        return '';
    }, [window.location.pathname]);

    return (
        <div>
            <style>
                {`
                    @media (min-width: 992px) and (max-width: 1239px) {
                        .title-admins {
                            display: none !important;
                        }
                    }
                    li {margin-left: 15px;}
                `}
            </style>
            <div className={currentSection === '' ? '' : 'd-none'}>
                <H2 title={'ADMINISTRADORES'} />
                <div className={card}>
                    <div className={cardHeader}>
                        <div className={header} style={headerStyles}>
                            Predicación
                        </div>
                        <button className={btnClasses}
                            style={btnStyles}
                            onClick={() => navigate('/admins/casa-en-casa')}
                            disabled={!user.isHthAdmin}
                        >
                            Casa en Casa
                        </button>
                        <button className={btnClasses}
                            style={btnStyles}
                            onClick={() => navigate('/admins/telefonica')}
                            disabled={!user.isTelephonicAdmin}
                        >
                            Telefónica
                        </button>
                        <button className={btnClasses}
                            style={btnStyles}
                            onClick={() => navigate('/admins/carritos')}
                            disabled={!user.isCartsAdmin}
                        >
                            Carritos
                        </button>
                        <button className={btnClasses}
                            style={btnStyles}
                            onClick={() => navigate('/admins/salidas')}
                            disabled={!user.isAdmin}
                        >
                            Serv. del Campo
                        </button>
                        <button className={btnClasses}
                            style={btnStyles}
                            onClick={() => navigate('/admins/mapa')}
                            disabled={!user.isHthAdmin}
                        >
                            Mapa
                        </button>
                        <button className={btnClasses}
                            style={btnStyles}
                            onClick={() => navigate('/admins/geriatricos')}
                            disabled={!user.isHthAdmin}
                        >
                            Geriátricos
                        </button>       
                        {/* <button className={btnClasses}
                            style={btnStyles}
                            onClick={() => navigate('/admins/informes')}
                            disabled
                        >
                            Informes
                        </button> */}
                    </div>
                </div>
                <div className={card}>
                    <div className={cardHeader}>
                        <div className={header} style={headerStyles}>
                            Reuniones
                        </div>
                        <button className={btnClasses}
                            style={btnStyles}
                            onClick={() => navigate('/admins/reuniones-entresemana')}
                            disabled={!user.isMeetingsAdmin}
                        >
                            Vida y Ministerio
                        </button>
                        <button className={btnClasses}
                            style={btnStyles}
                            onClick={() => navigate('/admins/reuniones-findesemana')}
                            disabled={!user.isMeetingsAdmin}
                        >
                            Reunión Pública
                        </button>
                        <button className={btnClasses}
                            style={btnStyles}
                            onClick={() => navigate('/admins/av-y-acomodadores')}
                            disabled={!user.isMeetingsAdmin}
                        >
                            AV y Acomod.
                        </button>
                        <button className={btnClasses}
                            style={btnStyles}
                            onClick={() => navigate('/admins/limpieza')}
                            disabled={!user.isMeetingsAdmin}
                        >
                            Limpieza
                        </button>
                        <button className={btnClasses}
                            style={btnStyles}
                            onClick={() => navigate('/admins/asistencia')}
                            disabled={!user.isMeetingsAdmin}
                        >
                            Asistencia
                        </button>
                    </div>
                </div>
                <div className={card}>
                    <div className={cardHeader}>
                        <div className={header} style={headerStyles}>
                            Personas
                        </div>
                        <button className={btnClasses}
                            style={btnStyles}
                            onClick={() => navigate('/admins/usuarios')}
                            disabled={!user.isAdmin}
                        >
                            Usuarios
                        </button>
                        <button className={btnClasses}
                            style={btnStyles}
                            onClick={() => navigate('/admins/grupos')}
                            disabled={!user.isAdmin}
                        >
                            Grupos
                        </button>
                        <button className={btnClasses}
                            style={btnStyles}
                            onClick={() => navigate('/admins/notificaciones')}
                            disabled={!user.isAdmin}
                        >
                            Notificaciones
                        </button>
                    </div>
                </div>
                {/* <div className={card}>
                    <div className={cardHeader}>
                        <div className={header} style={headerStyles}>
                            Congregación
                        </div>
                        <button className={btnClasses}
                            style={btnStyles}
                            onClick={() => navigate('/admins/cuentas')}
                            disabled
                        >
                            Cuentas
                        </button>
                    </div>
                </div> */}
                <div className={card}>
                    <div className={cardHeader}>
                        <div className={header} style={headerStyles}>
                            Sistema
                        </div>
                        <button className={btnClasses}
                            style={btnStyles}
                            onClick={() => navigate('/admins/tablero')}
                            disabled={!user.isBoardAdmin}
                        >
                            Tablero
                        </button>
                        <button className={btnClasses}
                            style={btnStyles}
                            onClick={() => navigate('/admins/logs')}
                        >
                            Logs
                        </button>
                        <button className={btnClasses}
                            style={btnStyles}
                            onClick={() => navigate('/admins/config')}
                            disabled={!user.isAdmin}
                        >
                            Configuración
                        </button>
                    </div>
                </div>
            </div>
            {currentSection === 'attendance' && <Subpages.AdminsMeetingAttendance />}
            {currentSection === 'av-ushers' && <Subpages.AdminsAVUshers />}
            {currentSection === 'board' && <Subpages.AdminsBoard />}
            {currentSection === 'carts' && <Subpages.AdminsCarts />}
            {currentSection === 'cleaning' && <Subpages.AdminsRoomCleaning />}
            {currentSection === 'config' && <Subpages.AdminsConfig />}
            {currentSection === 'geriatrics' && <Subpages.AdminsGeriatricsMap />}
            {currentSection === 'groups' && <Subpages.AdminsGroups />}
            {currentSection === 'hth' && <Subpages.AdminsHTH />}
            {currentSection === 'logs' && <Subpages.AdminsLogs />}
            {currentSection === 'map' && <Subpages.AdminsMapa />}
            {currentSection === 'midweek-meetings' && <Subpages.AdminsMidweekMeetings />}
            {currentSection === 'notifications' && <Subpages.AdminsNotifications />}
            {currentSection === 'public-meetings' && <Subpages.AdminsPublicMeetings />}
            {currentSection === 'public-ministry' && <Subpages.AdminsPublicMinistry />}
            {currentSection === 'reports' && <Subpages.AdminsMonthlyReports />}
            {currentSection === 'telephonic' && <Subpages.AdminsTelephonic />}
            {currentSection === 'users' && <Subpages.AdminsUsers />}
        </div>
    );
}
